export enum CommitmentDetailsDialogColumnId {
    DIRECT_REPORT = 'direct-report', // userId
    START_DATE = 'start-date', // goalStartDate
    DAYS_ACTIVE = 'days-active', // ageGoal
    METRIC = 'metric', // metricId
    BEHAVIOUR = 'behaviour', // behaviourId
    SUB_BEHAVIOUR = 'subBehaviour', // subBehaviourId
    STATE = 'state', // winning/neutral/losing
    CALCULATION_TYPE = 'calculation-type', // calculationType
    IMPROVEMENT_PERCENTAGE = 'improvement-percentage', // percentageChangeVariance
    WINNING_THRESHOLD = 'winning-threshold', // winningThresholdConfig
    INITIAL_VALUE = 'initial-value', // calculationType === actual => initialPerformance | calculationType === %ToTarget => initialPerToTarget
    CURRENT_VALUE = 'current-value', // calculationType === actual => finalPerformance | calculationType === %ToTarget => finalPerToTarget
    WINS_AT = 'wins-at', // winningThresholdResult
    STATUS = 'status', // commitmentStatusId
    VIEW_COMMITMENT = 'view-commitment', // commitmentId
    DISPOSITION = 'disposition', // excludedReasonId
}
